import { Search, X } from 'lucide-react'

export function SearchBar({ value, onChange, onClear, placeholder = 'Search products...' }) {
  return (
    <div className="relative w-full max-w-xl">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <Search className="h-5 w-5 text-brand-slate" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-brand-slate/20 bg-white py-2.5 pl-10 pr-10 text-sm text-brand-ink shadow-sm outline-none transition-all placeholder:text-brand-slate/60 focus:border-brand-gold focus:ring-2 focus:ring-brand-gold/20"
      />
      {value && (
        <button
          onClick={onClear}
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-brand-slate hover:text-brand-ink"
          aria-label="Clear search"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
